import { BaseRow } from 'app/components/common/BaseRow'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { Create } from './components/Create'
import { FilterManagement } from './components/FilterManagementTable'
import { useHookTable } from './hook'
import { useGetHeightTable } from 'app/hook'
import { BaseCol } from 'app/components/common/BaseCol'
const SkillManagementContainer = () => {
  const {
    tableData,
    columns,
    handleTableChange,
    fetchNewData,
    filter,
    handleChangeFilter,
    industries,
    levelSkills,
    rangeExperiences,
  } = useHookTable()
  return (
    <S.BaseManagementWrapper>
      <S.RootWrapper size={8}>
        <BaseRow gutter={6} justify={'space-between'} align={'middle'}>
          <BaseCol>
            <FilterManagement
              handleChangeFilter={handleChangeFilter}
              filterData={filter}
              industries={industries}
              levelSkills={levelSkills}
              rangeExperiences={rangeExperiences}
            />
          </BaseCol>
          <BaseCol>
            <Create fetchTable={fetchNewData} />
          </BaseCol>
        </BaseRow>
        <BaseTableManagement
          columns={columns}
          dataSource={tableData.data}
          pagination={tableData.pagination}
          loading={tableData.loading}
          onChange={handleTableChange}
          scroll={{
            x: true,
            y: tableData?.data?.length ? useGetHeightTable(195, 30) : undefined,
          }}
        />
      </S.RootWrapper>
    </S.BaseManagementWrapper>
  )
}
export default SkillManagementContainer
